module.exports = __webpack_public_path__ + "static/img/external_link.ab71fbbf.svg";